import { queryOptions } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import { assertDefined } from "app/pages/sales-intelligence/utils/errors/assertions";

import { savedSearchFiltersQueryKeys } from "./queryKeyFactory";

export const createSavedSearchQuery = (savedSearchId: string | null) =>
    queryOptions({
        queryKey: savedSearchFiltersQueryKeys.getById(savedSearchId),
        queryFn() {
            assertDefined(savedSearchId, { name: "savedSearchId", component: "createSavedSearchQuery" });

            return salesApiService.leadsSearch.savedSearches.fetchSearchById(savedSearchId);
        },
        staleTime: Number.POSITIVE_INFINITY,
    });
